import { HttpContextToken, HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { TaskListRefreshService } from './task-list-refresh.service';

// Marks a POST that only reads data (for example the task search), so it does not count as a write.
export const TASK_LIST_READ_ONLY = new HttpContextToken<boolean>(() => false);

// A successful write can change what the tasks list shows, so the list is marked stale.
export function taskListStaleInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const taskListRefresh = inject(TaskListRefreshService);

  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse && req.method !== 'GET' && !req.context.get(TASK_LIST_READ_ONLY)) {
        taskListRefresh.markStale();
      }
    }),
  );
}
